import { baseSelect } from '../selector-utils';

// ------------------------------------------------------------------------------------------------
// Simple
// ------------------------------------------------------------------------------------------------

export const selectActiveTab = baseSelect('productTab.selectedProductTab', undefined);
